import { createInstance } from "@datapunt/matomo-tracker-react";
import { Config } from "config";
import MatomoTracker from "@datapunt/matomo-tracker-js";

export const setupMatomo = (config: Config): MatomoTracker => {
  return createInstance({
    urlBase: config.matomoBaseUrl,
    siteId: config.matomoSiteId,
    trackerUrl: config.matomoBaseUrl + "/matomo.php",
    srcUrl: config.matomoBaseUrl + "/matomo.js",
    disabled: false,
    heartBeat: {
      active: true,
      seconds: 10
    },
    linkTracking: false,
    configurations: {
      disableCookies: true,
      setSecureCookie: true,
      setRequestMethod: "POST"
    }
  });
};
